import { messages } from "../contactFilters/messages"

export const supplierTotals = []

export const supplierFields = [
    'name',
    'nameAnalyzed',
    'nameKeyword',
    'email',
    'emailKeyword',
    'nameSort',
    'phoneNumber',
    'phoneNumberKeywordSearch',
]

export const getSuppliersFilters = function (context) {
    var filtersToUse =
        [
            {
                section: context.intl?.formatMessage(messages["most_used_filters"]),
            },
            {
                nameId: 'isArchived',
                label: context.intl?.formatMessage(messages["is_archived"]),
                filterMatch: 'isArchived',
                type: 'boolean',
                placeHolder: 'Show archived',
                initialValue: '',
                initialSelect: 'is',
            },
            {
                nameId: 'updatedAt',
                label: context.intl?.formatMessage(messages["updated_at"]),
                filterMatch: 'updatedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'contactId',
                label: context.intl?.formatMessage(messages["supplier"]),
                filterMatch: '_id',
                type: 'select',
                typeOfSelect: 'supplier-select',
                initialValue: "",
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'name',
                label: context.intl?.formatMessage(messages["supplier_name"]),
                filterMatch: 'name',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'phoneNumber',
                label: context.intl?.formatMessage(messages["contact_phonenumber"]),
                filterMatch: 'phoneNumberKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'email',
                label: context.intl?.formatMessage(messages["contact_email"]),
                filterMatch: 'emailKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
        ]

    return filtersToUse
}


// WEBPACK FOOTER //
// ./src/common/search-filter/search/supplierFilters/suppliersFilters.jsx